import createApolloClient from './createApolloClient';
import msalClient from '@auth/msal/client';

const apolloClient = createApolloClient(
    msalClient,
    import.meta.env.VITE_API_URI,
);

export default apolloClient;
